<!--
/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */
-->

<div class="cookie-modal">
  <div class="modal-header cookie-header">
    <div class="cookie-title-group">
      <div class="cookie-icon-badge">
        <osk-icon name="shield" [size]="20" />
      </div>
      <h4 class="modal-title" id="modal-basic-title">
        {{ 'cookieConsent.title' | oskTranslate | async }}
      </h4>
    </div>
  </div>

  <div class="modal-body cookie-body">
    <p class="cookie-intro">
      {{ 'cookieConsent.introPrefix' | oskTranslate | async }}
      <a href="https://oskey.io/privacy" data-automation-id="privacy-policy-link">{{
        'cookieConsent.privacyPolicy' | oskTranslate | async
      }}</a>
      {{ 'cookieConsent.and' | oskTranslate | async }}
      <a href="https://oskey.io/cookies" data-automation-id="cookie-policy-link">{{
        'cookieConsent.cookiePolicy' | oskTranslate | async
      }}</a
      >.
      {{ 'cookieConsent.introSuffix' | oskTranslate | async }}
    </p>

    <form [formGroup]="cookieConsentForm" class="cookie-options">
      <div class="form-check cookie-option-card">
        <input
          class="form-check-input"
          id="consentToStricklyNecessaryCookies"
          type="checkbox"
          checked=""
          formControlName="consentToStricklyNecessaryCookies"
          data-automation-id="consentToStricklyNecessaryCookies-checkbox"
          [ngClass]="{
            'is-invalid': wasSubmitted && f['consentToStricklyNecessaryCookies'].errors
          }"
        />
        <label class="form-check-label" for="consentToStricklyNecessaryCookies">
          <strong>{{ 'cookieConsent.strictlyNecessaryTitle' | oskTranslate | async }}</strong>
          {{ 'cookieConsent.strictlyNecessaryDesc' | oskTranslate | async }}
        </label>
      </div>

      <div class="form-check cookie-option-card">
        <input
          class="form-check-input"
          id="consentToPerformanceCookies"
          type="checkbox"
          formControlName="consentToPerformanceCookies"
          data-automation-id="consentToPerformanceCookies-checkbox"
        />
        <label class="form-check-label" for="consentToPerformanceCookies">
          <strong>{{ 'cookieConsent.performanceTitle' | oskTranslate | async }}</strong>
          {{ 'cookieConsent.performanceDesc' | oskTranslate | async }}
        </label>
      </div>

      <div class="form-check cookie-option-card">
        <input
          class="form-check-input"
          id="consentToTargetingCookies"
          type="checkbox"
          formControlName="consentToTargetingCookies"
          data-automation-id="consentToTargetingCookies-checkbox"
        />
        <label class="form-check-label" for="consentToTargetingCookies">
          <strong>{{ 'cookieConsent.targetingTitle' | oskTranslate | async }}</strong>
          {{ 'cookieConsent.targetingDesc' | oskTranslate | async }}
        </label>
      </div>
    </form>
  </div>

  <div class="modal-footer cookie-footer">
    <osk-button
      color="neutral"
      appearance="outline"
      size="md"
      data-automation-id="only-necessary-btn"
      (clicked)="close(true)"
    >
      {{ 'cookieConsent.onlyNecessary' | oskTranslate | async }}
    </osk-button>
    <osk-button
      color="primary"
      appearance="solid"
      size="md"
      data-automation-id="save-selection-btn"
      (clicked)="close(false)"
    >
      {{ 'cookieConsent.saveSelection' | oskTranslate | async }}
    </osk-button>
  </div>
</div>
